<template>
  <div class="beta-label">
    BETA
  </div>
</template>

<script>
  export default {
    name: 'BetaLabel',
  }
</script>

<style>
.beta-label {
    display: inline-block;
    text-align: center;
    vertical-align: text-top;
    width: 38px;
    height: 15px;
    font-size: 10px;
    font-weight: bold;
    border-radius: 15px;
    background-color: #694361;
    color: white;
    text-transform: uppercase;
    padding: 0 5px;
    line-height: 15px !important;
}
</style>
